/** The wall-clock time where the member is, or nothing when their zone is unknown. */
export function formatLocalTime(
	timeZone: string | undefined,
	now: Date = new Date(),
): string | null {
	if (!timeZone) return null
	try {
		return new Intl.DateTimeFormat(undefined, {
			hour: "2-digit",
			minute: "2-digit",
			hour12: false,
			timeZone,
		}).format(now)
	} catch {
		return null
	}
}
